module.exports = {"510411001":"大河中路街道","510411100":"仁和镇","510411101":"平地镇","510411102":"大田镇","510411103":"福田镇","510411104":"同德镇","510411105":"金江镇","510411106":"布德镇","510411107":"前进镇","510411200":"大龙潭彝族乡","510411201":"啊喇彝族乡","510411202":"总发乡","510411203":"太平乡","510411204":"务本乡","510411205":"中坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510411.json
// module id = 2103
// module chunks = 0